import { api } from "@/lib/axios"
import type { Material, MaterialsResponse, MaterialDetailResponse, MaterialColor, ColorsResponse, MaterialType, WireTypesResponse, MaterialIncome, MaterialIncomesResponse } from "@/types/materials"

export async function fetchMaterials(): Promise<Material[]> {
  const { data } = await api.get<MaterialsResponse>("/materials/")
  return data.data
}

export async function fetchMaterialDetail(id: number): Promise<Material> {
  const { data } = await api.get<MaterialDetailResponse>(`/materials/${id}/`)
  return data.data
}

export async function fetchColors(): Promise<MaterialColor[]> {
  const { data } = await api.get<ColorsResponse>("/materials/colors/")
  return data.data
}

export async function fetchWireTypes(): Promise<MaterialType[]> {
  const { data } = await api.get<WireTypesResponse>("/materials/wire-types/")
  return data.data
}
export interface UpdateMaterialPayload {
  name: string
  thickness: number
  weight: number
  color_id: number
  type_id: number
}

export async function updateMaterial(id: number, payload: UpdateMaterialPayload): Promise<Material> {
  const { data } = await api.patch<MaterialDetailResponse>(`/materials/${id}/`, payload)
  return data.data
}

export async function deleteMaterial(id: number): Promise<void> {
  await api.delete(`/materials/${id}/`)
}

export async function createColor(name: string): Promise<MaterialColor> {
  const { data } = await api.post<MaterialDetailResponse>("/materials/colors/", { name })
  return data.data as unknown as MaterialColor
}

export async function createWireType(name: string): Promise<MaterialType> {
  const { data } = await api.post<MaterialDetailResponse>("/materials/wire-types/", { name })
  return data.data as unknown as MaterialType
}

export async function updateColor(id: number, name: string): Promise<MaterialColor> {
  const { data } = await api.patch<MaterialDetailResponse>(`/materials/colors/${id}/`, { name })
  return data.data as unknown as MaterialColor
}

export async function updateWireType(id: number, name: string): Promise<MaterialType> {
  const { data } = await api.patch<MaterialDetailResponse>(`/materials/wire-types/${id}/`, { name })
  return data.data as unknown as MaterialType
}

export async function deleteColor(id: number): Promise<void> {
  await api.delete(`/materials/colors/${id}/`)
}

export async function deleteWireType(id: number): Promise<void> {
  await api.delete(`/materials/wire-types/${id}/`)
}

export async function fetchMaterialIncomes(): Promise<MaterialIncome[]> {
  const { data } = await api.get<MaterialIncomesResponse>("/materials/material-incomes/")
  return data.data
}

export async function deleteMaterialIncome(id: number): Promise<void> {
  await api.delete(`/materials/material-incomes/${id}/`)
}

export interface CreateMaterialIncomePayload {
  wire_name: string
  color: number
  wire_type: number
  thickness: number
  weight: number
  price: number
  supplier?: string
  arrived_time: string
  given_money?: number
}

export async function createMaterialIncome(payload: CreateMaterialIncomePayload): Promise<MaterialIncome> {
  const { data } = await api.post<{ status: number; message: string; data: MaterialIncome }>("/materials/material-incomes/", payload)
  return data.data
}
